import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class UserGroupRoleMaxUsersError extends CodedError {
  static get errorName() {
    return errorCodes.userGroupRoleMaxUsersError.code;
  }

  constructor(message: string = errorCodes.userGroupRoleMaxUsersError.message) {
    super(message);
    this.code = errorCodes.userGroupRoleMaxUsersError.code;
    this.message = `${message} ${errorCodes.userGroupRoleMaxUsersError.code}`;
    this.name = errorCodes.userGroupRoleMaxUsersError.name;
  }
}
